export const Draft = 'draft';
export const Published = 'published';
export const Archived = 'archived';
export const Statuses = {
  [Draft]: 'Draft',
  [Published]: 'Published',
  [Archived]: 'Archived',
};
